/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  commenting: {
    width: '100%',
    maxWidth: pxToEm(400),
    display: 'flex',
    flexDirection: 'column',
    gap: pxToEm(16),
    '& .placeholder': {
      background: '#EEEFF1', 
      borderRadius: '8px', 
      height: '10px',
      color: '#CDCDCD',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      fontWeight: 600,
      '&.rounded': {
        width: '24px', 
        height: '24px', 
        borderRadius: '40px',
        flex: 'none'
      }
    }
  }
});
